module.exports = __webpack_public_path__ + "img/XTRA WHEELS.203cb61e.png";